import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { Status } from '../../services/apiTypes';
import { createSelector } from 'reselect';

interface ImageState {
  status: Status;
  images: { [key: string]: { image: string; path: string }[] };
}

const initialState: ImageState = {
  status: 'idle',
  images: {},
};

const imagesSlice = createSlice({
  name: 'images',
  initialState,
  reducers: {
    addImage: (
      state,
      action: PayloadAction<{ key: string; image: string; path: string }>,
    ) => {
      const { key, image, path } = action.payload;
      if (!state.images[key]) {
        state.images[key] = [];
      }
      state.images[key].push({ image, path });
    },
    resetImages: (state) => {
      state.images = {};
    },
  },
});

export const { addImage, resetImages } = imagesSlice.actions;
export default imagesSlice.reducer;

export const selectImagesByKey = (key: string) =>
  createSelector(
    [(state: RootState) => state.ngSampleImages.images],
    (images) => images[key] || [],
  );
